const splitNumberIntoDigits = (number) => {
  let result = number.toLocaleString();
  result = result.split(',').join('\u00A0');

  return result;
};

export default splitNumberIntoDigits;
